import { ExternalSystem } from '../integration/externalSystem';

export class GetExternalSystemResponse {
  externalSystems: ExternalSystem[];

  constructor(externalSystems: ExternalSystem[]) {
    this.externalSystems = externalSystems;
  }
}
